export default __webpack_public_path__ + "static/media/uploading-file.3d55bba0.svg";